import { render, staticRenderFns } from "./DocumentTransferForOtherCompany.vue?vue&type=template&id=4b48781e&scoped=true"
import script from "./DocumentTransferForOtherCompany.vue?vue&type=script&lang=js"
export * from "./DocumentTransferForOtherCompany.vue?vue&type=script&lang=js"
import style0 from "./DocumentTransferForOtherCompany.vue?vue&type=style&index=0&id=4b48781e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48781e",
  null
  
)

export default component.exports